export enum Stores {
  moduleStructure = 'ModuleStructure',
  shoppingCart = 'shoppingCart',
}
